module.exports = __webpack_public_path__ + "static/media/operan.af29b28e.png";